import { useEffect, useState, ReactNode } from 'react';
import { THEME_LOCAL_STORAGE_KEY } from '@constants/local-storage';
import { DEFAULT_THEME } from '@constants/theme';
import useLocalStorage from '@hooks/use-local-storage';
import { CURRENT_INSTANCE } from '@lib/utils';
import ThemeProviderContext from '@stores/contexts/theme-context';

interface IThemeProviderProps {
  children: ReactNode;
  defaultTheme?: string;
  storageKey?: string;
}

function ThemeProvider({
  children,
  defaultTheme = DEFAULT_THEME,
  storageKey = `${THEME_LOCAL_STORAGE_KEY}_${CURRENT_INSTANCE.name}`,
  ...props
}: IThemeProviderProps) {
  const [localStorageTheme, setLocalStorageTheme] = useLocalStorage<string>(
    storageKey,
    defaultTheme
  );
  const [theme, setTheme] = useState<string>(() => (localStorageTheme as string) || defaultTheme);

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.add(theme);
  }, [theme]);

  const value = {
    theme,
    setTheme: (theme: string) => {
      setLocalStorageTheme(theme);
      setTheme(theme);
    },
  };

  return (
    <ThemeProviderContext.Provider {...props} value={value}>
      {children}
    </ThemeProviderContext.Provider>
  );
}

export default ThemeProvider;
